// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/annotation-triage'

/** Strips the leading slash so a route can be used as a relative <Navigate> target. */
export const relative = (route: string) => route.replace(/^\//, '')

export const BaseAnnotationTriageAreaRoutes = {
  route: baseRoute,
  /** The annotations table, with the map beside it. */
  List: {
    route: '/list',
  },
  /** Stat cards, charts and the hotspots map over the same annotations. */
  Dashboard: {
    route: '/dashboard',
  },
  /**
   * The old weekly view's path. Kept only so bookmarks to it redirect to the
   * dashboard, which replaced it.
   */
  LegacyOverTime: {
    route: '/over-time',
  },
}

export const AnnotationTriageAreaRoutes = transformRoutes(
  BaseAnnotationTriageAreaRoutes,
)
